import { createApiClient } from "@platform/api-client";
import { useAuthStore, getRefreshToken } from "../stores/authStore";

const API_URL = import.meta.env.VITE_API_URL ?? "http://localhost:4000";

export const apiClient = createApiClient({
  baseUrl: API_URL,
  getAccessToken: () => useAuthStore.getState().accessToken,
  // Refresh token lives in memory only — never in localStorage
  getRefreshToken: () => getRefreshToken(),
  onTokensRefreshed: (tokens) => useAuthStore.getState().setTokens(tokens),
  onAuthExpired: () => useAuthStore.getState().clear(),
});
